/** Public route shown after user sign-out or cross-portal silent logout. */
export const SIGNED_OUT_ROUTE_PATH = '/signed-out';
